import * as StoryletActionTypes from 'actiontypes/storylet';

const chooseBranchFailure = error => ({
  type: StoryletActionTypes.CHOOSE_BRANCH_FAILURE,
  error: true,
  status: error.response && error.response.status,
});

export default chooseBranchFailure;